import { computed } from 'vue';
import { type Skin, Direction } from 'data-types-config';

/**
 * useSkin - Common styling logic shared by all interactive elements.
 * Handles common properties like direction and fontWeight.
 */
export default function useSkin(props: Partial<Skin>) {
  const allClasses = computed(() => {
    const directionClass = (() => {
      switch (props.direction) {
        case Direction.Bottom:
          return 'flex-column';
        case Direction.Top:
          return 'flex-column-reverse';
        case Direction.Left:
          return 'flex-row-reverse';
        case Direction.Right:
          return 'flex-row';
        default:
          return '';
      }
    })();

    const additionalClasses = [
      props.fontWeight ? `fw-${props.fontWeight}` : '',
    ].filter(Boolean);

    return [directionClass, ...additionalClasses].join(' ');
  });

  return {
    allClasses,
  };
}
